// Shared display formatters.

import i18n from "@/i18n";

/**
 * Human-readable binary size ("1.5 MiB"); "—" for unknown. The number
 * follows the UI language ("1,5 MiB" in Dutch and French).
 */
export function formatBytes(n: number | null | undefined): string {
  if (n === null || n === undefined) return "—";
  const units = ["B", "KiB", "MiB", "GiB", "TiB"];
  let value = n;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  const digits = unit === 0 ? 0 : 1;
  const formatted = new Intl.NumberFormat(i18n.language || "en", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
    useGrouping: false,
  }).format(value);
  return `${formatted} ${units[unit]}`;
}
